import { Col, Row } from 'react-bootstrap';
import styled from 'styled-components';
import { PRIMARY_COLOR } from '../../components/Common/StyleElement';

export const ApplicationButtonRow = styled(Col)`
    display: flex;
    justify-content: center;
    > span {
        margin: 0 1rem;
    }
`

export const ApplicationRow = styled(Row)`
    padding-bottom: 1rem;
`

export const TrackBase = styled.div`
    border: 2px solid ${PRIMARY_COLOR};
    border-radius: 10px;
    height: 768px;
    padding: 10px;
    //overflow-x: scroll;
    //overflow-y: scroll;
  
    //This code can stop the scroll bar in parent element.
    overscroll-behavior: contain;
`